import { createSelector } from 'reselect';
import { arrayToMap } from '../../utils/collections';

function deviceIdFn(d) {
  return d.staging_id;
}
function topicFn(p) {
  return p.topic;
}
function equipIdFn(e) {
  return e.equip_id;
}

const getBuildingStaging = createSelector(
  [
    (state, buildingId) => state.entities.staging.devicesByBuilding[buildingId],
    (state, buildingId) => state.entities.staging.pointsByBuilding[buildingId],
    (state, buildingId) => state.entities.staging.equipmentByBuilding[buildingId],
    (state, buildingId) => state.entities.staging.validation.points[buildingId],
    (state, buildingId) => state.entities.staging.validation.equipment[buildingId],
  ],
  (
    devicesList,
    pointsList,
    equipmentList,
    pointValidationByTopic,
    equipmentValidationByEquipId
  ) => {
    const devices = arrayToMap(devicesList ?? [], deviceIdFn);
    const equipment = arrayToMap(
      (equipmentList ?? []).map((equip) => ({
        ...equip,
        points: [],
        devices: [],
        validation: equipmentValidationByEquipId[equip.equip_id] ?? undefined,
      })),
      equipIdFn
    );
    const points = arrayToMap(
      Object.values(pointsList ?? {}).map((point) => {
        const device = devices.get(point.staging_device_id);
        const newPoint = {
          ...point,
          validation: pointValidationByTopic[point.topic] ?? undefined,
          equip: point.equip_ids.map((equipId) => equipment.get(equipId)).filter((e) => e),
          device,
        };
        newPoint.equip.forEach((equip) => {
          equip.points.push(newPoint);
          if (
            device !== undefined &&
            !equip.devices.some((d) => d.staging_id === device.staging_id)
          ) {
            equip.devices.push(device);
          }
        });
        return newPoint;
      }),
      topicFn
    );

    return { devices, points, equipment };
  }
);

export default getBuildingStaging;
